export class TokenRefreshRequest {
  constructor(private refreshToken: string, private username?:string, private email?:string, private token?:string) {
  }
}
